import React from "react";
import {Link} from "react-router-dom";


export function UserInfoColumn(cellContent, row) {
    return (
        <>
            <span className="text-dark font-weight-bold text-hover-primary mb-1 font-size-lg">
                {row.fullName}
            </span>
        </>
    );
}

export function UserActiveColumn(cellContent, row) {
    const isActive = cellContent ?? row?.active ?? row?.isActive;
    return (
        <>
            {isActive ?
                <span className=" mb-1 font-size-md">
                    Yes
                </span> :
                <span className="  mb-1 font-size-md">
                    No
                </span>
            }
        </>
    );
}
